export const enum LockStatus {
  BLANK = 9001,
  DAMAGED = 9002,
  FREE = 9003,
  PAIRED = 9004,
}
